"use strict";
$(function ($) {
  $(".js-hamburger").click(function () {
    const $menuText = $(this).find(".menu-text");

    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open").addClass("is-closed");
      // テキストを「Menu」に戻す前にアニメーションを適用
      $menuText.css({
        opacity: 0,
        transform: "translateX(-50%) translateY(-10px)",
      });

      setTimeout(function () {
        $menuText
          .text("Menu")
          .css({ opacity: 1, transform: "translateX(-50%) translateY(0)" });
      }, 250);
    } else {
      $(this).removeClass("is-closed").addClass("is-open");
      // テキストを「Close」に変更する前にアニメーションを適用
      $menuText.css({
        opacity: 0,
        transform: "translateX(-50%) translateY(-10px)",
      });

      setTimeout(function () {
        $menuText
          .text("Close")
          .css({ opacity: 1, transform: "translateX(-50%) translateY(0)" });
      }, 250);
    }

    // ドロワーメニューの表示/非表示
    $(".js-drawer").fadeToggle();
  });

  // ドロワーナビのaタグをクリックで閉じる
  $(".js-drawer a[href]").on("click", function () {
    $(".js-hamburger").removeClass("is-open").addClass("is-closed");
    $(".js-drawer").fadeOut();
    $(".js-hamburger .menu-text").text("Menu");
  });

  // resizeイベント
  $(window).on("resize", function () {
    if (window.matchMedia("(min-width: 768px)").matches) {
      $(".js-hamburger").removeClass("is-open").addClass("is-closed");
      $(".js-drawer").fadeOut();
      $(".js-hamburger .menu-text").text("Menu");
    }
  });

  // new Splide(".splide").mount();

  // ファーストビュースライド
  const options2 = {
    mediaQuery: "min",
    type: "loop",
    autoplay: true,
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    interval: 4000,
    speed: 2000, // スライドの切り替え速度（ミリ秒）
    pauseOnHover: false, // ホバー時にスライドを停止しない
    breakpoints: {
      780: {
        perPage: 1,
        gap: "2rem",
      },
    },
  };
  const splide2 = new Splide("#js-intro__slider", options2);
  splide2.mount();

  // Service高さ調整を動的に
  function adjustParentHeight() {
    var parent = document.querySelector(".services__inner");
    var child = document.querySelector(".services__list");

    if (window.innerWidth > 780) {
      // ブレイクポイントが780pxを超える場合のみ実行
      parent.style.height = child.offsetHeight + "px";
    } else {
      // SP表示（780px未満）の場合、高さを自動にリセット
      parent.style.height = "auto";
    }
  }

  // 初期調整
  adjustParentHeight();

  // 画面サイズ変更時に再調整
  window.addEventListener("resize", adjustParentHeight);

  // topへ戻る
  const floating = $("#js-pagetop");
  floating.hide();
  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 70) {
      floating.fadeIn();
    } else {
      floating.fadeOut();
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const floating = document.getElementById('js-floating');
  const fvElement = document.querySelector('.fv') || document.querySelector('.underpage-fv');
  const fvHeight = fvElement ? fvElement.offsetHeight : 0;

  window.addEventListener('scroll', function() {
    const scrollY = window.pageYOffset;

    if (scrollY > fvHeight) {
      floating.classList.add('is-visible');
    } else {
      floating.classList.remove('is-visible');
    }
  });
});

document.querySelectorAll('.svPage-tab__tabTitle').forEach(tab => {
  tab.addEventListener('click', function() {
    // すべてのタブからactiveクラスを外す
    document.querySelectorAll('.svPage-tab__tabTitle').forEach(t => t.classList.remove('active'));

    // クリックしたタブと同じdata-tab属性を持つタブすべてにactiveクラスを追加
    const targetTab = this.getAttribute('data-tab');
    document.querySelectorAll(`.svPage-tab__tabTitle[data-tab="${targetTab}"]`).forEach(t => t.classList.add('active'));

    // すべてのコンテンツを非表示に
    document.querySelectorAll('.svPage-card').forEach(content => content.classList.remove('active'));

    // 対応するコンテンツを表示
    const contentId = `content-${targetTab}`;
    document.getElementById(contentId).classList.add('active');
  });
});

